// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no_data_box[data-v-39200d34]{width:500px;padding-top:265px;margin:auto;font-size:18px;font-weight:500;line-height:36px;color:#666;text-align:center}.no_data_box .btn[data-v-39200d34]{margin-top:53px}", ""]);
// Exports
module.exports = exports;
